import React, { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from 'contexts/AuthContext'
import CommunityService from 'service/CommunityService'
import { addItemToPanel, getMyPanel } from 'service/PersonalPanelService'
import AuthModal from 'components/AuthModal/AuthModal'
import Loader from 'components/Loader/Loader'
import Pagination from 'components/Pagination/Pagination'
import CreateChatModal from 'pages/Services/CommunityPage/components/CreateChatModal/CreateChatModal'
import styles from './ChatsPage.module.scss'

//  Icons 
const GlobeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
  </svg>
)
const LockIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
  </svg>
)
const MicIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5zm6 6c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/>
  </svg>
)
const PlusIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
  </svg>
)
const SearchIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
)
const PeopleIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
  </svg>
)
const SettingsIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 00.12-.61l-1.92-3.32a.49.49 0 00-.59-.22l-2.39.96a7.04 7.04 0 00-1.62-.94l-.36-2.54A.484.484 0 0014 2h-4a.484.484 0 00-.48.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96a.488.488 0 00-.59.22L2.74 8.87a.48.48 0 00.12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58a.49.49 0 00-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.37 1.04.7 1.62.94l.36 2.54c.05.24.27.41.48.41h4c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.57 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32a.49.49 0 00-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/>
  </svg>
)
const CopyIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
  </svg>
)
const PanelIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
    <path d="M4 5a2 2 0 012-2h12a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 3.25A1.25 1.25 0 008.25 9.5h2.5A1.25 1.25 0 0012 8.25v-.5A1.25 1.25 0 0010.75 6.5h-2.5A1.25 1.25 0 007 7.75v.5zm5 0A1.25 1.25 0 0013.25 9.5h2.5A1.25 1.25 0 0017 8.25v-.5A1.25 1.25 0 0015.75 6.5h-2.5A1.25 1.25 0 0012 7.75v.5zM7 13.75A1.25 1.25 0 008.25 15h2.5A1.25 1.25 0 0012 13.75v-.5A1.25 1.25 0 0010.75 12h-2.5A1.25 1.25 0 007 13.25v.5z"/>
  </svg>
)

function formatDate(dateStr) {
  if (!dateStr) return ''
  const s = String(dateStr)
  const m = s.match(/^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{2}):(\d{2})/)
  const d = m ? new Date(`${m[3]}-${m[2]}-${m[1]}T${m[4]}:${m[5]}`) : new Date(s.replace(' ', 'T'))
  if (!d || isNaN(d.getTime())) return s
  const now = new Date()
  const diffMin = Math.floor((now - d) / 60000)
  if (diffMin < 1) return 'только что'
  if (diffMin < 60) return `${diffMin} мин`
  const diffH = Math.floor(diffMin / 60)
  if (diffH < 24) return `${diffH} ч`
  if (diffH < 48) return 'вчера'
  return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' })
}

function getRoomTypeLabel(t) {
  return { public: 'Публичный', private: 'Приватный', voice: 'Голосовой', voice_private: 'Прив. голосовой' }[t] || t
}

function getAvatarLetter(name) { return (name || '?').charAt(0).toUpperCase() }

function getRoomIcon(room_type) {
  if (room_type === 'voice' || room_type === 'voice_private') return <MicIcon />
  if (room_type === 'private') return <LockIcon size={22} />
  return <GlobeIcon />
}

export default function ChatsPage() {
  const navigate = useNavigate()
  const { isAuthenticated, user } = useAuth()

  const [chatRooms, setChatRooms] = useState([])
  const [chatSearch, setChatSearch] = useState('')
  const [chatPage, setChatPage] = useState(1)
  const [chatTotalPages, setChatTotalPages] = useState(1)
  const [chatLoading, setChatLoading] = useState(false)
  const [panelChatIds, setPanelChatIds] = useState(new Set())
  const [categories, setCategories] = useState([])
  const [showAuthModal, setShowAuthModal] = useState(false)
  const [showCreateChat, setShowCreateChat] = useState(false)
  const [showInviteModal, setShowInviteModal] = useState(false)
  const [inviteCode, setInviteCode] = useState('')
  const [inviteError, setInviteError] = useState('')
  const [joiningSlug, setJoiningSlug] = useState(null)
  const [copiedCode, setCopiedCode] = useState(null)

  const loadChatRooms = useCallback(async () => {
    try {
      setChatLoading(true)
      const params = { page: chatPage }
      if (chatSearch.trim()) params.search = chatSearch.trim()
      const response = await CommunityService.getChatRooms(params)
      const data = response.data
      setChatRooms(data.results || data || [])
      setChatTotalPages(data.total_pages || 1)
    } catch (err) { /* ignore */ } finally { setChatLoading(false) }
  }, [chatPage, chatSearch])

  const loadPanelIds = useCallback(async () => {
    if (!isAuthenticated) return
    try {
      const response = await getMyPanel()
      const items = response.data?.items || []
      setPanelChatIds(new Set(items.filter(i => i.item_type === 'chat').map(i => String(i.item_id))))
    } catch (err) { /* ignore */ }
  }, [isAuthenticated])

  useEffect(() => {
    CommunityService.getCommunityCategories().then(r => setCategories(r.data || [])).catch(() => {})
  }, [])

  useEffect(() => { loadPanelIds() }, [loadPanelIds])

  useEffect(() => {
    const timer = setTimeout(loadChatRooms, chatSearch ? 300 : 0)
    return () => clearTimeout(timer)
  }, [loadChatRooms])

  const handleOpen = async (room) => {
    if (!isAuthenticated) { setShowAuthModal(true); return }
    if (room.is_member) {
      CommunityService.markChatRead(room.slug).catch(() => {})
      navigate('/services/community/chat/' + room.slug)
      return
    }
    if (room.room_type === 'private' || room.room_type === 'voice_private') { setShowInviteModal(true); return }
    setJoiningSlug(room.slug)
    try {
      await CommunityService.joinChatRoom(room.slug)
      CommunityService.markChatRead(room.slug).catch(() => {})
      navigate('/services/community/chat/' + room.slug)
    } catch (err) { /* ignore */ } finally { setJoiningSlug(null) }
  }

  const handleAddToPanel = async (room, e) => {
    e.stopPropagation()
    if (!isAuthenticated) { setShowAuthModal(true); return }
    const panelId = String(room.slug)
    try {
      await addItemToPanel('chat', panelId, { title: room.name, description: room.description || '', room_type: room.room_type, category_name: room.category_name })
      setPanelChatIds(prev => new Set(prev).add(panelId))
    } catch (err) {
      if (err?.response?.status === 400) setPanelChatIds(prev => new Set(prev).add(panelId))
    }
  }

  const handleInviteJoin = async () => {
    if (!inviteCode.trim()) return
    setInviteError('')
    try {
      await CommunityService.joinByInviteCode(inviteCode.trim())
      setShowInviteModal(false)
      setInviteCode('')
      await loadChatRooms()
    } catch (err) { setInviteError('Неверный код приглашения') }
  }

  const handleCopyCode = (e, code) => {
    e.stopPropagation()
    navigator.clipboard.writeText(code)
    setCopiedCode(code)
    setTimeout(() => setCopiedCode(null), 1800)
  }

  const handleCreateChatRoom = async (roomData) => {
    if (!isAuthenticated) { setShowAuthModal(true); return null }
    const response = await CommunityService.createChatRoom({ name: roomData.name, description: roomData.description, room_type: roomData.room_type, category: roomData.category || null })
    await loadChatRooms()
    return response.data
  }

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}> Чаты</h1>
        <div className={styles.headerActions}>
          <button className={styles.inviteEntryBtn} onClick={() => setShowInviteModal(true)}>
            <LockIcon size={14} /> По инвайту
          </button>
          {isAuthenticated && (
            <button className={styles.createBtn} onClick={() => setShowCreateChat(true)}>
              <PlusIcon /> Создать
            </button>
          )}
        </div>
      </div>

      <div className={styles.searchWrap}>
        <SearchIcon />
        <input className={styles.searchInput} type="text" placeholder="Поиск чатов..." value={chatSearch}
          onChange={e => { setChatSearch(e.target.value); setChatPage(1) }} />
      </div>

      <div className={styles.list}>
        {chatLoading && chatRooms.length === 0 ? (
          <div className={styles.loader}><Loader size="medium" /></div>
        ) : chatRooms.length === 0 ? (
          <div className={styles.empty}>
            <span className={styles.emptyIcon}></span>
            <p>{chatSearch ? `По запросу ${chatSearch} ничего не найдено` : 'Чатов пока нет'}</p>
            {isAuthenticated && !chatSearch && (
              <button className={styles.createBtnEmpty} onClick={() => setShowCreateChat(true)}><PlusIcon /> Создать первый чат</button>
            )}
          </div>
        ) : chatRooms.map(room => {
          const inPanel = panelChatIds.has(String(room.slug))
          const isOwner = user && room.owner?.id === user.id
          const isVoice = room.room_type === 'voice' || room.room_type === 'voice_private'
          const isPrivate = room.room_type === 'private' || room.room_type === 'voice_private'
          return (
            <div key={room.id}
              className={`${styles.card} ${room.is_member ? styles.cardMember : ''} ${room.is_active ? styles.cardActive : ''}`}
              onClick={() => handleOpen(room)}>

              <div className={`${styles.ava} ${styles['ava_' + room.room_type]}`}>
                <span className={styles.avaLetter}>{getAvatarLetter(room.name)}</span>
                <span className={styles.avaIcon}>{getRoomIcon(room.room_type)}</span>
                {room.is_active && <span className={styles.activeDot} />}
              </div>

              <div className={styles.body}>
                <div className={styles.topRow}>
                  <span className={styles.name}>{room.name}</span>
                  <span className={styles.time}>{formatDate(room.last_message_at)}</span>
                </div>
                <div className={styles.metaRow}>
                  <span className={`${styles.typeBadge} ${styles['type_' + room.room_type]}`}>{getRoomTypeLabel(room.room_type)}</span>
                  {room.is_member && <span className={styles.memberBadge}> Участник</span>}
                  {isOwner && <span className={styles.ownerBadge}>Владелец</span>}
                  <span className={styles.memberCount}><PeopleIcon /> {room.members_count || 0}</span>
                  {room.category_name && <span className={styles.catLabel}>{room.category_name}</span>}
                </div>
                {room.description && <p className={styles.desc}>{room.description}</p>}

                {isOwner && isPrivate && room.invite_code && (
                  <div className={styles.inviteCodeRow} onClick={e => e.stopPropagation()}>
                    <span className={styles.inviteCodeLabel}>Инвайт-код:</span>
                    <code className={styles.inviteCodeVal}>{room.invite_code}</code>
                    <button className={styles.copyBtn} onClick={e => handleCopyCode(e, room.invite_code)} title="Копировать">
                      {copiedCode === room.invite_code ? '' : <CopyIcon />}
                    </button>
                  </div>
                )}

                <div className={styles.actionBar} onClick={e => e.stopPropagation()}>
                  {/* LEFT: unread count */}
                  <div className={styles.unreadWrap}>
                    {room.unread_count > 0 && (
                      <span className={styles.unreadBadge}>
                        {room.unread_count > 99 ? '99+' : room.unread_count}
                      </span>
                    )}
                  </div>
                  {/* RIGHT: action buttons */}
                  <div className={styles.btnGroup}>
                    {!isAuthenticated ? (
                      <button className={styles.authBtn} onClick={() => setShowAuthModal(true)}>Войти для участия</button>
                    ) : room.is_member ? (
                      <button className={`${styles.openBtn} ${isVoice ? styles.openBtnVoice : ''}`}
                        onClick={() => handleOpen(room)}>
                        {isVoice ? '🎙 Войти' : '💬 Открыть'}
                      </button>
                    ) : isPrivate ? (
                      <button className={styles.inviteEntryBtnRow} onClick={() => setShowInviteModal(true)}>
                        <LockIcon size={14} /> Войти по инвайту
                      </button>
                    ) : (
                      <button className={`${styles.joinBtn} ${isVoice ? styles.joinBtnVoice : ''}`}
                        disabled={joiningSlug === room.slug} onClick={() => handleOpen(room)}>
                        {joiningSlug === room.slug ? '⏳ Подключение...' : isVoice ? '🎙 Подключиться' : '➕ Вступить'}
                      </button>
                    )}
                    {isAuthenticated && (
                      <button className={`${styles.panelBtn} ${inPanel ? styles.panelBtnIn : ''}`}
                        onClick={e => handleAddToPanel(room, e)} title={inPanel ? 'Уже в панели' : 'Добавить в Мой хаб'}>
                        <PanelIcon /> {inPanel ? 'В панели' : 'В панель'}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>

      {chatTotalPages > 1 && (
        <div className={styles.paginationWrap}>
          <Pagination currentPage={chatPage} totalPages={chatTotalPages} onPageChange={p => setChatPage(p)} />
        </div>
      )}

      <AuthModal open={showAuthModal} onClose={() => setShowAuthModal(false)} />

      {showCreateChat && (
        <CreateChatModal isOpen={showCreateChat} onClose={() => setShowCreateChat(false)}
          onSubmit={handleCreateChatRoom} categories={categories} />
      )}

      {showInviteModal && (
        <div className={styles.overlay} onClick={() => setShowInviteModal(false)}>
          <div className={styles.modal} onClick={e => e.stopPropagation()}>
            <h3> Войти по коду приглашения</h3>
            <p className={styles.modalHint}>Введите код, который передал владелец приватного чата</p>
            <input className={styles.codeInput} type="text" placeholder="Код приглашения..." value={inviteCode}
              onChange={e => setInviteCode(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleInviteJoin()} autoFocus />
            {inviteError && <p className={styles.inviteError}>{inviteError}</p>}
            <div className={styles.modalActions}>
              <button className={styles.cancelBtn} onClick={() => { setShowInviteModal(false); setInviteCode(''); setInviteError('') }}>Отмена</button>
              <button className={styles.confirmBtn} onClick={handleInviteJoin} disabled={!inviteCode.trim()}>Войти</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}